import { Box } from '@mui/material';

import { Alignments } from '../../../../../shared/components/ui/Table/enums/alignments.enum';
import { TableColumnDef } from '../../../../../shared/components/ui/Table/models/table-column.model';
import { castTo } from '../../../../../shared/utils/cast-to';
import { StatisticsModel } from '../../models/statistics.model';

export const statisticsTableColumnDefUtil: TableColumnDef[] = [
  {
    field: 'date',
    headerName: 'Date',
    alignment: Alignments.LEFT,
    width: '17.86%',
    valueGetter: row => {
      return <Box>{castTo<StatisticsModel>(row).date}</Box>;
    },
  },
  {
    field: 'allVersions',
    headerName: <Box sx={{ mx: '24px' }}>All Versions</Box>,
    alignment: Alignments.LEFT,
    width: '21.15%',
    valueGetter: row => (
      <Box sx={{ mx: '20px' }}>{castTo<StatisticsModel>(row).allVersions}</Box>
    ),
  },
  {
    field: 'android12',
    headerName: <Box sx={{ mx: '24px' }}>Android 12</Box>,
    alignment: Alignments.LEFT,
    width: '17.67%',
    valueGetter: row => (
      <Box sx={{ mx: '20px' }}>{castTo<StatisticsModel>(row).android12}</Box>
    ),
  },
  {
    field: 'android10',
    headerName: 'Android 10',
    alignment: Alignments.LEFT,
    width: '15.11%',
    valueGetter: row => castTo<StatisticsModel>(row).android10,
  },
  {
    field: 'android13',
    headerName: 'Android 13',
    alignment: Alignments.LEFT,
    width: '16.12%',
    valueGetter: row => castTo<StatisticsModel>(row).android13,
  },
  {
    field: 'android9',
    headerName: 'Android 9',
    alignment: Alignments.LEFT,
    width: '12.09%',
    valueGetter: row => castTo<StatisticsModel>(row).android9,
  },
];
